import { render, staticRenderFns } from "./Topmenu.vue?vue&type=template&id=32c50a04"
import script from "./Topmenu.vue?vue&type=script&lang=js"
export * from "./Topmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports